<div class="header-fixed w-100">
    <!-- <div class="news-scroll">
        <div class="newsbtn">
            <mat-icon> list_alt</mat-icon>
            <span class="ms-1">News</span>
        </div>
        <ul class="mb-0 p-0">
            <li>We are India’s market leader in commercial vehicles and amongst the top three in the passenger vehicles
                market. </li>
        </ul>
    </div> -->

    <div class="header-new" id="scroll-uptoheader">
        <div class="logoContainer">
            <!-- <a class="me-3" type="button" data-bs-toggle="offcanvas" data-bs-target="#NavbarOffcanvas"
                aria-controls="NavbarOffcanvas">
                <mat-icon>sort</mat-icon>
               
            </a> -->
            <div class="svg-middle-align cursor-pointer">
                <!-- <img src="../../../../assets/images/logo.svg" class="LGI_Logo" alt="Liberty Partner First Home"
          title="Liberty Partner First Home" /> -->
                <img src="../../../../assets/images/liberty-logo.webp" class="LGI_Logo" alt="Liberty General Insurance"
                    title="Liberty General Insurance" width="164" height="56" />
            </div>
        </div>
    </div>
</div>

<!-- <div class="container-fluid px-lg-4">
    <div class="formConatiner"> -->

        <mat-accordion *ngIf="responseData">
            <mat-expansion-panel [(expanded)]="defaultShow">
                <mat-expansion-panel-header>
                    <mat-panel-title> Endorsement Details - {{responseData?.endorsementCategory}} - {{responseData?.endorsementType}}</mat-panel-title>
                </mat-expansion-panel-header>

                <div class="row mb-2 newold-endorsement">
                    <!-- Old Details -->
                    <div *ngIf="responseData?.enCode === policyConstant?.CustomerDetailsInsuredName_Code"
                        class="col-md-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row mb-2">
                                <div class="col">
                                    <label class="labelName d-block">First Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldFirstValue}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Last Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldLastValue}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="responseData?.enCode === policyConstant?.EngineChassisInterchange_Code || responseData?.enCode === policyConstant?.EngineChassisMaxTwoDigits_Code"
                        class="col-md-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row mb-2">
                                <div class="col">
                                    <label class="labelName d-block">Engine Number</label>
                                    <label class="labelValue">{{endorsementDetails?.oldFirstValue}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Chassis Number</label>
                                    <label class="labelValue">{{endorsementDetails?.oldLastValue}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="responseData?.enCode === policyConstant?.CustomerDetailsCommunicationAddress_Code"
                        class="col-md-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Address Line 1</label>
                                    <label class="labelValue">{{endorsementDetails?.oldAddress1}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Address Line 2</label>
                                    <label class="labelValue">{{endorsementDetails?.oldAddress2}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Mobile</label>
                                    <label class="labelValue">{{endorsementDetails?.oldMobileNumber}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Pincode</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPincode}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">City</label>
                                    <label class="labelValue">{{endorsementDetails?.oldCity}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">State</label>
                                    <label class="labelValue">{{endorsementDetails?.oldState}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Email</label>
                                    <label class="labelValue">{{endorsementDetails?.oldEmailId}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="endorsementService._enCode === policyConstant?.TransferofInsurance_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">First Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldfirstName ?
                                        endorsementDetails?.oldfirstName :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Last Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldlastName ?
                                        endorsementDetails?.oldlastName : '-'}}</label>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Pan Number</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPanNo ? endorsementDetails?.oldPanNo
                                        : endorsementDetails?.PanNo || '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Date Of Birth</label>
                                    <label class="labelValue">{{endorsementDetails?.olddateOfBirth ||
                                        endorsementDetails?.DateOfBirth ?
                                        endorsementDetails?.olddateOfBirth :'-'}}</label>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Gender</label>
                                    <label class="labelValue">{{endorsementDetails?.oldgender ? endorsementDetails?.oldgender :
                                        '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Email</label>
                                    <label class="labelValue">{{endorsementDetails?.oldemailId ? endorsementDetails?.oldemailId
                                        : '-'}}</label>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Mobile Number</label>
                                    <label class="labelValue">{{endorsementDetails?.oldmobileNo ?
                                        endorsementDetails?.oldmobileNo :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Address</label>
                                    <label class="labelValue">{{endorsementDetails?.oldmailingAddress ?
                                        endorsementDetails?.oldmailingAddress :'-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Pin Code</label>
                                    <label class="labelValue">{{endorsementDetails?.oldmailingPinCode ?
                                        endorsementDetails?.oldmailingPinCode : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">State</label>
                                    <label class="labelValue">{{endorsementDetails?.oldMailingState ?
                                        endorsementDetails?.oldMailingState : '-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">City</label>
                                    <label class="labelValue">{{endorsementDetails?.oldMailingDistrict ?
                                        endorsementDetails?.oldMailingDistrict : '-'}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="bg-light">
                            <h6>Old Financier Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Financier Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldFinancierNames ?
                                        endorsementDetails?.oldFinancierNames : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Financier Address</label>
                                    <label class="labelValue">{{endorsementDetails?.oldFinancierAddresss ?
                                        endorsementDetails?.oldFinancierAddresss : '-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Aggrement Type</label>
                                    <label class="labelValue">{{endorsementDetails?.oldAggrementType ?
                                        endorsementDetails?.oldAggrementType : '-'}}</label>
                                </div>
        
                            </div>
                        </div>
                        <div class="bg-light">
                            <h6>Old Nominee Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nominee First Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldnomineeFirstName ?
                                        endorsementDetails?.oldnomineeFirstName : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nominee Middle Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldnomineeMiddleName ?
                                        endorsementDetails?.oldnomineeMiddleName : '-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nominee Last Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldnomineeLastName ?
                                        endorsementDetails?.oldnomineeLastName : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Relationship</label>
                                    <label class="labelValue">{{endorsementDetails?.oldRelationshipWiththeInsured ?
                                        endorsementDetails?.oldRelationshipWiththeInsured : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nominee isMinor</label>
                                    <label class="labelValue">{{endorsementDetails?.oldnomineeIsMinor ?
                                        endorsementDetails?.oldnomineeIsMinor :'-'}}</label>
                                </div>
        
                            </div>
                            <div class="row">
                                <div *ngIf="endorsementDetails?.oldRelationship === 'Other'" class="col-sm-6">
                                    <label class="labelName d-block">Other Relationship</label>
                                    <label class="labelValue">{{endorsementDetails?.oldotherRelationship ?
                                        endorsementDetails?.oldotherRelationship :'-'}}</label>
                                </div>
        
                            </div>
                            <div *ngIf="endorsementDetails?.oldIsMinor === 'yes'">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Reprentative First Name</label>
                                        <label class="labelValue">{{endorsementDetails?.oldrepresentativeFirstName ?
                                            endorsementDetails?.oldrepresentativeFirstName : '-'}}</label>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Reprentative Middle Name</label>
                                        <label class="labelValue">{{endorsementDetails?.oldrepresentativeMiddleName ?
                                            endorsementDetails?.oldrepresentativeMiddleName : '-'}}</label>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Reprentative Last Name</label>
                                        <label class="labelValue">{{endorsementDetails?.oldrepresentativeLastName ?
                                            endorsementDetails?.oldrepresentativeLastName :'-'}}</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Relationship with the Minor</label>
                                        <label class="labelValue">{{endorsementDetails?.oldrelationshipWiththeMinor ?
                                            endorsementDetails?.oldrelationshipWiththeMinor : '-'}}</label>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Other Relationship</label>
                                        <label class="labelValue">{{endorsementDetails?.oldotherRepresentativeRelationship ?
                                            endorsementDetails?.oldotherRepresentativeRelationship :'-'}}</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Relationship with the Insured Data</label>
                                        <label class="labelValue">{{endorsementDetails?.oldrelationshipWiththeInsured ?
                                            endorsementDetails?.oldrelationshipWiththeInsured :'-'}}</label>
                                    </div>
        
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="responseData?.enCode === policyConstant?.NoclaimBonus_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Is Previous Claim</label>
                                    <label class="labelValue">{{endorsementDetails?.oldIsPreviousClaim === '0' ? 'No':
                                        'Yes'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">NCB as per policy %</label>
                                    <label class="labelValue">{{endorsementDetails?.oldNCBasperpolicy ?
                                        endorsementDetails?.oldNCBasperpolicy : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODDis>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODDis ?
                                        endorsementDetails?.oldPropRisks_DetariffODDis : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODDisY2>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODDisY2 ?
                                        endorsementDetails?.oldPropRisks_DetariffODDisY2 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODDisY3>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODDisY3 ?
                                        endorsementDetails?.oldPropRisks_DetariffODDisY3 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODDisYr4>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODDisYr4 ?
                                        endorsementDetails?.oldPropRisks_DetariffODDisYr4 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODDisYr5>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODDisYr5 ?
                                        endorsementDetails?.oldPropRisks_DetariffODDisYr5 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODLoad>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODLoad ?
                                        endorsementDetails?.oldPropRisks_DetariffODLoad : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODLoadY2>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODLoadY2 ?
                                        endorsementDetails?.oldPropRisks_DetariffODLoadY2 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODLoadY3>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODLoadY3 ?
                                        endorsementDetails?.oldPropRisks_DetariffODLoadY3 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.oldPropRisks_DetariffODLoadY4>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.oldPropRisks_DetariffODLoadY4 ?
                                        endorsementDetails?.oldPropRisks_DetariffODLoadY4 : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="responseData?.enCode === policyConstant?.ZoneReRegistration_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Zone</label>
                                    <label class="labelValue">{{endorsementDetails?.oldZone ?
                                        endorsementDetails?.oldZone :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Regsistartion No.</label>
                                    <label class="labelValue">{{endorsementDetails?.oldRegsistartionNo ?
                                        endorsementDetails?.oldRegsistartionNo : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="responseData?.enCode === policyConstant?.CorrectionofRegistrationNo_Code"
                        class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Zone</label>
                                    <label class="labelValue">{{endorsementDetails?.oldCorrectionofZone ?
                                        endorsementDetails?.oldCorrectionofZone :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Regsistartion No.</label>
                                    <label class="labelValue">{{endorsementDetails?.oldCorrectionofRegsistartionNo ?
                                        endorsementDetails?.oldCorrectionofRegsistartionNo : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="responseData?.enCode === policyConstant?.CustomerDetailsInsuredName_Code"
                        class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">First Name</label>
                                    <label class="labelValue">{{endorsementDetails?.firstName}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Last Name</label>
                                    <label class="labelValue">{{endorsementDetails?.lastName}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="responseData?.enCode === policyConstant?.ZoneReRegistration_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="col">
                                        <label class="labelName d-block">Zone</label>

                                    </div>
                                    <div class="col">

                                        <label class="labelValue">{{endorsementDetails?.oldZone ?
                                            endorsementDetails?.oldZone :'-'}}</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="col">
                                        <label class="labelName d-block">Registration Number</label>

                                    </div>
                                    <div class="col">

                                        <label class="labelValue">{{endorsementDetails?.oldRegsistartionNo ?
                                            endorsementDetails?.oldRegsistartionNo :'-'}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="endorsementService._enCode === policyConstant?.InclusionofIMT_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">IMT 23 coverage</label>
                                    <label class="labelValue">{{endorsementDetails?.oldImt23Coverage ? endorsementDetails?.oldImt23Coverage : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="endorsementService._enCode === policyConstant?.InclusionofIMTcoverage_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">IMT 47 coverage</label>
                                    <label class="labelValue">{{endorsementDetails?.oldImt47Coverage ? endorsementDetails?.oldImt47Coverage : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="endorsementService._enCode === policyConstant?.changeofEitherRegNo_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Regsistartion No.</label>
                                    <label class="labelValue">{{endorsementDetails?.oldRegsistartionNo ? endorsementDetails?.oldRegsistartionNo : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Chassis Number</label>
                                    <label class="labelValue">{{endorsementDetails?.oldChassisNo ? endorsementDetails?.oldChassisNo : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Engine Number</label>
                                    <label class="labelValue">{{endorsementDetails?.oldEngineNo ? endorsementDetails?.oldEngineNo : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="endorsementService._enCode === policyConstant?.ExtensionofGeographicalArea_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Geographical Extension</label>
                                    <label class="labelValue">{{endorsementDetails?.oldGeographicalExtension ? endorsementDetails?.oldGeographicalExtension : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nation</label>
                                    <label class="labelValue">{{getOldNations(endorsementDetails) || '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div *ngIf="endorsementService._enCode === policyConstant?.InclusionofelectricalOrNonElectrical_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row mb-2">
                                <div class="col-md-12">
                                  <label class="labelName d-block">Electrical Accessories</label>
                                </div>
                                <div class="col-md-12">
                                  <table mat-table [dataSource]="endorsementDetails.oldElectricalAccessories">
                                    <ng-container matColumnDef="make">
                                      <th mat-header-cell *matHeaderCellDef> Make </th>
                                      <td mat-cell *matCellDef="let element"> {{element.make}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="model">
                                      <th mat-header-cell *matHeaderCellDef> Model </th>
                                      <td mat-cell *matCellDef="let element"> {{element.model}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="serialNo">
                                      <th mat-header-cell *matHeaderCellDef> Serial No. </th>
                                      <td mat-cell *matCellDef="let element"> {{element.serialNo}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="sumInsured">
                                      <th mat-header-cell *matHeaderCellDef> Sum Insured </th>
                                      <td mat-cell *matCellDef="let element"> {{element.sumInsured}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="description">
                                      <th mat-header-cell *matHeaderCellDef> Description </th>
                                      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                                    </ng-container>
                                    <tr mat-header-row
                                      *matHeaderRowDef="['make', 'model', 'serialNo', 'sumInsured', 'description']">
                                    </tr>
                                    <tr mat-row
                                      *matRowDef="let row; columns: ['make', 'model', 'serialNo', 'sumInsured', 'description'];">
                                    </tr>
                                  </table>
                                </div>
                                <div class="col-md-12">
                                  <label class="labelName d-block">Non-Electrical Accessories</label>
                                </div>
                                <div class="col-md-12">
                                  <table mat-table [dataSource]="endorsementDetails.oldNonElectricalAccessories">
                                    <ng-container matColumnDef="make">
                                      <th mat-header-cell *matHeaderCellDef> Make </th>
                                      <td mat-cell *matCellDef="let element"> {{element.make}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="model">
                                      <th mat-header-cell *matHeaderCellDef> Model </th>
                                      <td mat-cell *matCellDef="let element"> {{element.model}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="manufacturingYear">
                                      <th mat-header-cell *matHeaderCellDef> Manufacturing Year </th>
                                      <td mat-cell *matCellDef="let element"> {{element.manufacturingYear}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="serialNo">
                                      <th mat-header-cell *matHeaderCellDef> Serial No. </th>
                                      <td mat-cell *matCellDef="let element"> {{element.serialNo}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="sumInsured">
                                      <th mat-header-cell *matHeaderCellDef> Sum Insured </th>
                                      <td mat-cell *matCellDef="let element"> {{element.sumInsured}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="description">
                                      <th mat-header-cell *matHeaderCellDef> Description </th>
                                      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                                    </ng-container>
                                    <tr mat-header-row
                                      *matHeaderRowDef="['make', 'model', 'manufacturingYear', 'serialNo', 'sumInsured', 'description']">
                                    </tr>
                                    <tr mat-row
                                      *matRowDef="let row; columns: ['make', 'model', 'manufacturingYear', 'serialNo', 'sumInsured', 'description'];">
                                    </tr>
                                  </table>
                                </div>
                              </div>
                        </div>
                    </div>
        
                    <div *ngIf="endorsementService._enCode === policyConstant?.Manufacturingyearonly_Code" class="col-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Manufacturing Year</label>
                                    <label class="labelValue">{{endorsementDetails?.oldYearOfManufacture ? endorsementDetails?.oldYearOfManufacture : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- New Details (For Engine and Chassis Number) -->
                    <div class="col-md-6"
                        *ngIf="responseData?.enCode === policyConstant?.EngineChassisInterchange_Code || responseData?.enCode === policyConstant?.EngineChassisMaxTwoDigits_Code">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Engine Number</label>
                                    <label class="labelValue">{{endorsementDetails?.engineNumber}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Chassis Number</label>
                                    <label class="labelValue">{{endorsementDetails?.chassisNumber}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6"
                        *ngIf="responseData?.enCode === policyConstant?.CustomerDetailsCommunicationAddress_Code">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Address Line 1</label>
                                    <label class="labelValue">{{endorsementDetails?.newAddress1}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Address Line 2</label>
                                    <label class="labelValue">{{endorsementDetails?.newAddress2}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Mobile</label>
                                    <label class="labelValue">{{endorsementDetails?.newMobileNumber}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Pincode</label>
                                    <label class="labelValue">{{endorsementDetails?.newPincode}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">City</label>
                                    <label class="labelValue">{{endorsementDetails?.newCity}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">State</label>
                                    <label class="labelValue">{{endorsementDetails?.newState}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Email</label>
                                    <label class="labelValue">{{endorsementDetails?.newEmailId}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6"
                        *ngIf="responseData?.enCode === policyConstant?.FinancierDetailsIncorporation_Code || responseData?.enCode === policyConstant?.FinancierDetailsAmendment_Code || responseData?.enCode === policyConstant?.FinancierDetailsDeletion_Code">
                        <div class="bg-light">
                            <h6>Old Financier Details</h6>
                            <div class="row mb-2">
                                <div class="col">
                                    <label class="labelName d-block">Financier Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldFinancierNames}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Financier Address</label>
                                    <label class="labelValue">{{endorsementDetails?.oldFinancierAddresss}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Financier Type</label>
                                    <label class="labelValue">{{endorsementDetails?.oldAggrementType}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6"
                        *ngIf="responseData?.enCode === policyConstant?.FinancierDetailsIncorporation_Code || responseData?.enCode === policyConstant?.FinancierDetailsAmendment_Code || responseData?.enCode === policyConstant?.FinancierDetailsDeletion_Code">
                        <div class="bg-light">
                            <h6>New Financier Details</h6>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Financier
                                        Name</label>
                                    <label class="labelValue">{{endorsementDetails?.newFinancierName}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Financier Address</label>
                                    <label class="labelValue">{{endorsementDetails?.newFinancierAddress}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Financier Type</label>
                                    <label class="labelValue">{{endorsementDetails?.newFinancierType}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="responseData?.enCode === policyConstant?.NomineeDetails_Code" class="col-md-6">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row mb-2">
                                <div class="col">
                                    <label class="labelName d-block">First Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldFirstName}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Middle Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldMiddleName}}</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col">
                                    <label class="labelName d-block">Last Name</label>
                                    <label class="labelValue">{{endorsementDetails?.oldLastName}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Relationship</label>
                                    <label class="labelValue">{{endorsementDetails?.oldRelationship}}</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div *ngIf="endorsementDetails?.oldRelationship === 'Other'" class="col">
                                    <label class="labelName d-block">Other Relationship</label>
                                    <label class="labelValue">{{endorsementDetails?.oldOtherRelationship}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Is Minor</label>
                                    <label class="labelValue">{{endorsementDetails?.oldIsMinor}}</label>
                                </div>
                            </div>
                            <!-- Show Old Representative Details if Is Minor is Yes -->
                            <div *ngIf="endorsementDetails?.oldIsMinor === 'yes'">
                                <div class="row mb-2">
                                    <div class="col">
                                        <label class="labelName d-block">Representative First Name</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.oldRepresentativeFirstName}}</label>
                                    </div>
                                    <div class="col">
                                        <label class="labelName d-block">Representative Middle Name</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.oldRepresentativeMiddleName}}</label>
                                    </div>
                                </div>
                                <div class="row mb-2">

                                    <div class="col">
                                        <label class="labelName d-block">Representative Last Name</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.oldRepresentativeLastName}}</label>
                                    </div>
                                    <div class="col">
                                        <label class="labelName d-block">Relationship With Minor</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.oldRelationshipWithMinor}}</label>
                                    </div>
                                </div>
                                <!-- Show Old Other Representative Relationship if Relationship With Minor is 'Other' -->
                                <div class="row mb-2" *ngIf="endorsementDetails?.oldRelationshipWithMinor === 'Other'">
                                    <div class="col">
                                        <label class="labelName d-block">Other Representative Relationship</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.oldOtherRepresentativeRelationShip}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="responseData?.enCode === policyConstant?.NomineeDetails_Code" class="col-md-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">First Name</label>
                                    <label class="labelValue">{{endorsementDetails?.newFirstName}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Middle Name</label>
                                    <label class="labelValue">{{endorsementDetails?.newMiddleName}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="labelName d-block">Last Name</label>
                                    <label class="labelValue">{{endorsementDetails?.newLastName}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Relationship</label>
                                    <label class="labelValue">{{endorsementDetails?.newRelationship}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div *ngIf="endorsementDetails?.newRelationship === 'Other'" class="col">
                                    <label class="labelName d-block">Other Relationship</label>
                                    <label class="labelValue">{{endorsementDetails?.newOtherRelationship}}</label>
                                </div>
                                <div class="col">
                                    <label class="labelName d-block">Is Minor</label>
                                    <label class="labelValue">{{endorsementDetails?.newIsMinor}}</label>
                                </div>
                            </div>
                            <!-- Show New Representative Details if Is Minor is Yes -->
                            <div *ngIf="endorsementDetails?.newIsMinor === 'yes'">
                                <div class="row mb-2">
                                    <div class="col">
                                        <label class="labelName d-block">Representative First Name</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.newRepresentativeFirstName}}</label>
                                    </div>
                                    <div class="col">
                                        <label class="labelName d-block">Representative Middle Name</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.newRepresentativeMiddleName}}</label>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col">
                                        <label class="labelName d-block">Representative Last Name</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.newRepresentativeLastName}}</label>
                                    </div>
                                    <div class="col">
                                        <label class="labelName d-block">Relationship With Minor</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.newRelationshipWithMinor}}</label>
                                    </div>
                                </div>
                                <div class="row mb-2" *ngIf="endorsementDetails?.newRelationshipWithMinor === 'Other'">
                                    <div class="col">
                                        <label class="labelName d-block">Other Representative Relationship</label>
                                        <label
                                            class="labelValue">{{endorsementDetails?.newOtherRepresentativeRelationShip}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="endorsementService._enCode === policyConstant?.TransferofInsurance_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">First Name</label>
                                    <label class="labelValue">{{endorsementDetails?.firstName ? endorsementDetails?.firstName :
                                        '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Last Name</label>
                                    <label class="labelValue">{{endorsementDetails?.lastName ? endorsementDetails?.lastName :
                                        '-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6" *ngIf="endorsementDetails?.panNumber">
                                    <label class="labelName d-block">Pan Number</label>
                                    <label class="labelValue">{{endorsementDetails?.panNumber ? endorsementDetails?.panNumber
                                        :'-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.ckycAadharNumber">
                                    <label class="labelName d-block">Aadhaar Number</label>
                                    <label class="labelValue">{{endorsementDetails?.ckycAadharNumber ?
                                        endorsementDetails?.ckycAadharNumber
                                        :'-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.ckycNumber">
                                    <label class="labelName d-block">CKYC Number</label>
                                    <label class="labelValue">{{endorsementDetails?.ckycNumber ? endorsementDetails?.ckycNumber
                                        :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Date Of Birth</label>
                                    <label class="labelValue">{{endorsementDetails?.dateOfBirth ? (
                                        endorsementDetails?.dateOfBirth | date:'dd/MM/yyyy' ): '-'}}</label>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Gender</label>
                                    <label class="labelValue">{{endorsementDetails?.gender ? endorsementDetails?.gender :
                                        '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Email</label>
                                    <label class="labelValue">{{endorsementDetails?.emailId ? endorsementDetails?.emailId
                                        :'-'}}</label>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Mobile Number</label>
                                    <label class="labelValue">{{endorsementDetails?.mobileNo ? endorsementDetails?.mobileNo
                                        :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block"> Address</label>
                                    <label class="labelValue">{{endorsementDetails?.mailingAddress ?
                                        endorsementDetails?.mailingAddress : '-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Pin Code</label>
                                    <label class="labelValue">{{endorsementDetails?.mailingPinCode ?
                                        endorsementDetails?.mailingPinCode :'-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">State</label>
                                    <label class="labelValue">{{endorsementDetails?.state ?
                                        endorsementDetails?.state : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">City</label>
                                    <label class="labelValue">{{endorsementDetails?.mailingTownOrCity ?
                                        endorsementDetails?.mailingTownOrCity : '-'}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="bg-light">
                            <h6>Financial Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Financier Name</label>
                                    <label class="labelValue">{{endorsementDetails?.financierName ?
                                        endorsementDetails?.financierName : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Financier Address</label>
                                    <label class="labelValue">{{endorsementDetails?.fianncierAddress ?
                                        endorsementDetails?.fianncierAddress : '-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Aggrement Type</label>
                                    <label class="labelValue">{{endorsementDetails?.AggrementType ?
                                        endorsementDetails?.AggrementType : '-'}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="bg-light">
                            <h6>Nominee Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nominee First Name</label>
                                    <label class="labelValue">{{endorsementDetails?.nomineeFirstName ?
                                        endorsementDetails?.nomineeFirstName :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nominee Middle Name</label>
                                    <label class="labelValue">{{endorsementDetails?.nomineeMiddleName ?
                                        endorsementDetails?.nomineeMiddleName :'-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nominee Last Name</label>
                                    <label class="labelValue">{{endorsementDetails?.nomineeLastName ?
                                        endorsementDetails?.nomineeLastName :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Relationship</label>
                                    <label class="labelValue">{{endorsementDetails?.relationshipWiththeInsured ?
                                        endorsementDetails?.relationshipWiththeInsured : '-'}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div *ngIf="endorsementDetails?.relationshipWiththeInsured === 'Other'" class="col-sm-6">
                                    <label class="labelName d-block">Other Relationship</label>
                                    <label class="labelValue">{{endorsementDetails?.otherRelationship ?
                                        endorsementDetails?.otherRelationship :'-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nominee isMinor</label>
                                    <label class="labelValue">{{endorsementDetails?.nomineeIsMinor ?
                                        endorsementDetails?.nomineeIsMinor : '-'}}</label>
                                </div>
                            </div>
                            <div *ngIf="endorsementDetails?.nomineeIsMinor === 'yes'">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Reprentative First Name</label>
                                        <label class="labelValue">{{endorsementDetails?.representativeFirstName ?
                                            endorsementDetails?.representativeFirstName : '-'}}</label>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Reprentative Middle Name</label>
                                        <label class="labelValue">{{endorsementDetails?.representativeMiddleName ?
                                            endorsementDetails?.representativeMiddleName : '-'}}</label>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Reprentative Last Name</label>
                                        <label class="labelValue">{{endorsementDetails?.representativeLastName ?
                                            endorsementDetails?.representativeLastName : '-'}}</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Relationship with the Minor</label>
                                        <label class="labelValue">{{endorsementDetails?.relationshipWiththeMinor ?
                                            endorsementDetails?.relationshipWiththeMinor :'-'}}</label>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Other Relationship</label>
                                        <label class="labelValue">{{endorsementDetails?.otherRepresentativeRelationship ?
                                            endorsementDetails?.otherRepresentativeRelationship :'-'}}</label>
                                    </div>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-sm-6">
                                        <label class="labelName d-block">Relationship with the Insured Data</label>
                                        <label class="labelValue">{{endorsementDetails?.relationshipWiththeInsured ?
                                            endorsementDetails?.relationshipWiththeInsured :'-'}}</label>
                                    </div>
        
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <div *ngIf="responseData?.enCode === policyConstant?.NoclaimBonus_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Is Previous Claim</label>
                                    <label class="labelValue">{{endorsementDetails?.IsPreviousClaim === '0' ? 'No':
                                        'Yes'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">NCB as per policy %</label>
                                    <label class="labelValue">{{endorsementDetails?.NCBasperpolicy ?
                                        endorsementDetails?.NCBasperpolicy : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODDis>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODDis ?
                                        endorsementDetails?.PropRisks_DetariffODDis : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODDisY2>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODDisY2 ?
                                        endorsementDetails?.PropRisks_DetariffODDisY2 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODDisY3>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODDisY3 ?
                                        endorsementDetails?.PropRisks_DetariffODDisY3 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODDisYr4>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODDisYr4 ?
                                        endorsementDetails?.PropRisks_DetariffODDisYr4 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODDisYr5>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODDisYr5 ?
                                        endorsementDetails?.PropRisks_DetariffODDisYr5 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODLoad>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODLoad ?
                                        endorsementDetails?.PropRisks_DetariffODLoad : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODLoadY2>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODLoadY2 ?
                                        endorsementDetails?.PropRisks_DetariffODLoadY2 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODLoadY3>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODLoadY3 ?
                                        endorsementDetails?.PropRisks_DetariffODLoadY3 : '-'}}</label>
                                </div>
                                <div class="col-sm-6" *ngIf="endorsementDetails?.PropRisks_DetariffODLoadY4>0">
                                    <label class="labelName d-block">OD discount</label>
                                    <label class="labelValue">{{endorsementDetails?.PropRisks_DetariffODLoadY4 ?
                                        endorsementDetails?.PropRisks_DetariffODLoadY4 : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="responseData?.enCode === policyConstant?.ZoneReRegistration_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Zone</label>
                                    <label class="labelValue">{{endorsementDetails?.Zone ? endorsementDetails?.Zone :
                                        '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Regsistartion No.</label>
                                    <label class="labelValue">{{endorsementDetails?.RegsistartionNo ?
                                        endorsementDetails?.RegsistartionNo : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="responseData?.enCode === policyConstant?.CorrectionofRegistrationNo_Code"
                        class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Zone</label>
                                    <label class="labelValue">{{endorsementDetails?.Zone ? endorsementDetails?.Zone :
                                        '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Regsistartion No.</label>
                                    <label class="labelValue">{{endorsementDetails?.RegsistartionNo ?
                                        endorsementDetails?.RegsistartionNo : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="endorsementService._enCode === policyConstant?.InclusionofIMT_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <mat-slide-toggle class="toggleHorizontal" disabled [checked]="endorsementDetails?.newImt23Coverage">IMT 23 coverage
                                        <a href="#" class="tooltipicon" data-bs-toggle="tooltip" data-bs-title="Default tooltip">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                                            <g opacity="0.5">
                                              <path
                                                d="M6.4165 4.58341H7.58317V5.75008H6.4165V4.58341ZM6.99984 10.4167C7.32067 10.4167 7.58317 10.1542 7.58317 9.83341V7.50008C7.58317 7.17925 7.32067 6.91675 6.99984 6.91675C6.679 6.91675 6.4165 7.17925 6.4165 7.50008V9.83341C6.4165 10.1542 6.679 10.4167 6.99984 10.4167ZM6.99984 1.66675C3.77984 1.66675 1.1665 4.28008 1.1665 7.50008C1.1665 10.7201 3.77984 13.3334 6.99984 13.3334C10.2198 13.3334 12.8332 10.7201 12.8332 7.50008C12.8332 4.28008 10.2198 1.66675 6.99984 1.66675ZM6.99984 12.1667C4.42734 12.1667 2.33317 10.0726 2.33317 7.50008C2.33317 4.92758 4.42734 2.83341 6.99984 2.83341C9.57234 2.83341 11.6665 4.92758 11.6665 7.50008C11.6665 10.0726 9.57234 12.1667 6.99984 12.1667Z"
                                                fill="#333740" />
                                            </g>
                                          </svg>
                                        </a>
                                      </mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="endorsementService._enCode === policyConstant?.InclusionofIMTcoverage_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <mat-slide-toggle class="toggleHorizontal" disabled [checked]="endorsementDetails?.newImt47Coverage">IMT 47 coverage
                                        <a href="#" class="tooltipicon" data-bs-toggle="tooltip" data-bs-title="Default tooltip">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                                            <g opacity="0.5">
                                              <path
                                                d="M6.4165 4.58341H7.58317V5.75008H6.4165V4.58341ZM6.99984 10.4167C7.32067 10.4167 7.58317 10.1542 7.58317 9.83341V7.50008C7.58317 7.17925 7.32067 6.91675 6.99984 6.91675C6.679 6.91675 6.4165 7.17925 6.4165 7.50008V9.83341C6.4165 10.1542 6.679 10.4167 6.99984 10.4167ZM6.99984 1.66675C3.77984 1.66675 1.1665 4.28008 1.1665 7.50008C1.1665 10.7201 3.77984 13.3334 6.99984 13.3334C10.2198 13.3334 12.8332 10.7201 12.8332 7.50008C12.8332 4.28008 10.2198 1.66675 6.99984 1.66675ZM6.99984 12.1667C4.42734 12.1667 2.33317 10.0726 2.33317 7.50008C2.33317 4.92758 4.42734 2.83341 6.99984 2.83341C9.57234 2.83341 11.6665 4.92758 11.6665 7.50008C11.6665 10.0726 9.57234 12.1667 6.99984 12.1667Z"
                                                fill="#333740" />
                                            </g>
                                          </svg>
                                        </a>
                                      </mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="endorsementService._enCode === policyConstant?.changeofEitherRegNo_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Regsistartion No.</label>
                                    <label class="labelValue">{{endorsementDetails?.RegistrationNo ? endorsementDetails?.RegistrationNo : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Chassis Number</label>
                                    <label class="labelValue">{{endorsementDetails?.newChassisNo ? endorsementDetails?.newChassisNo : '-'}}</label>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Engine Number</label>
                                    <label class="labelValue">{{endorsementDetails?.newEngineNo ? endorsementDetails?.newEngineNo : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="endorsementService._enCode === policyConstant?.ExtensionofGeographicalArea_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-slide-toggle class="toggleHorizontal" disabled [checked]="endorsementDetails?.GeographicalExtension">
                                      Geographical Extension
                                      <a href="#" class="tooltipicon" data-bs-toggle="tooltip" data-bs-title="Default tooltip">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                                          <g opacity="0.5">
                                            <path
                                              d="M6.4165 4.58341H7.58317V5.75008H6.4165V4.58341ZM6.99984 10.4167C7.32067 10.4167 7.58317 10.1542 7.58317 9.83341V7.50008C7.58317 7.17925 7.32067 6.91675 6.99984 6.91675C6.679 6.91675 6.4165 7.17925 6.4165 7.50008V9.83341C6.4165 10.1542 6.679 10.4167 6.99984 10.4167ZM6.99984 1.66675C3.77984 1.66675 1.1665 4.28008 1.1665 7.50008C1.1665 10.7201 3.77984 13.3334 6.99984 13.3334C10.2198 13.3334 12.8332 10.7201 12.8332 7.50008C12.8332 4.28008 10.2198 1.66675 6.99984 1.66675ZM6.99984 12.1667C4.42734 12.1667 2.33317 10.0726 2.33317 7.50008C2.33317 4.92758 4.42734 2.83341 6.99984 2.83341C9.57234 2.83341 11.6665 4.92758 11.6665 7.50008C11.6665 10.0726 9.57234 12.1667 6.99984 12.1667Z"
                                              fill="#333740" />
                                          </g>
                                        </svg>
                                      </a>
                                    </mat-slide-toggle>
                                </div>
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Nation</label>
                                    <label class="labelValue">
                                      {{
                                        getNations(endorsementDetails) || '-'
                                      }}
                                    </label>
                                  </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="endorsementService._enCode === policyConstant?.InclusionofelectricalOrNonElectrical_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row mb-2">
                                <div class="col-md-12">
                                  <label class="labelName d-block">Electrical Accessories</label>
                                </div>
                                <div class="col-md-12">
                                  <table mat-table [dataSource]="endorsementDetails.electricalAccessories">
                                    <ng-container matColumnDef="make">
                                      <th mat-header-cell *matHeaderCellDef> Make </th>
                                      <td mat-cell *matCellDef="let element"> {{element.make}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="model">
                                      <th mat-header-cell *matHeaderCellDef> Model </th>
                                      <td mat-cell *matCellDef="let element"> {{element.model}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="serialNo">
                                      <th mat-header-cell *matHeaderCellDef> Serial No. </th>
                                      <td mat-cell *matCellDef="let element"> {{element.serialNo}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="sumInsured">
                                      <th mat-header-cell *matHeaderCellDef> Sum Insured </th>
                                      <td mat-cell *matCellDef="let element"> {{element.sumInsured}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="description">
                                      <th mat-header-cell *matHeaderCellDef> Description </th>
                                      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                                    </ng-container>
                                    <tr mat-header-row
                                      *matHeaderRowDef="['make', 'model', 'serialNo', 'sumInsured', 'description']">
                                    </tr>
                                    <tr mat-row
                                      *matRowDef="let row; columns: ['make', 'model', 'serialNo', 'sumInsured', 'description'];">
                                    </tr>
                                  </table>
                                </div>
                                <div class="col-md-12">
                                  <label class="labelName d-block">Non-Electrical Accessories</label>
                                </div>
                                <div class="col-md-12">
                                  <table mat-table [dataSource]="endorsementDetails.nonElectricalAccessories">
                                    <ng-container matColumnDef="make">
                                      <th mat-header-cell *matHeaderCellDef> Make </th>
                                      <td mat-cell *matCellDef="let element"> {{element.make}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="model">
                                      <th mat-header-cell *matHeaderCellDef> Model </th>
                                      <td mat-cell *matCellDef="let element"> {{element.model}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="manufacturingYear">
                                      <th mat-header-cell *matHeaderCellDef> Manufacturing Year </th>
                                      <td mat-cell *matCellDef="let element"> {{element.manufacturingYear}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="serialNo">
                                      <th mat-header-cell *matHeaderCellDef> Serial No. </th>
                                      <td mat-cell *matCellDef="let element"> {{element.serialNo}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="sumInsured">
                                      <th mat-header-cell *matHeaderCellDef> Sum Insured </th>
                                      <td mat-cell *matCellDef="let element"> {{element.sumInsured}} </td>
                                    </ng-container>
                  
                                    <ng-container matColumnDef="description">
                                      <th mat-header-cell *matHeaderCellDef> Description </th>
                                      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                                    </ng-container>
                                    <tr mat-header-row
                                      *matHeaderRowDef="['make', 'model', 'manufacturingYear', 'serialNo', 'sumInsured', 'description']">
                                    </tr>
                                    <tr mat-row
                                      *matRowDef="let row; columns: ['make', 'model', 'manufacturingYear', 'serialNo', 'sumInsured', 'description'];">
                                    </tr>
                                  </table>
                                </div>
                              </div>
                        </div>
                    </div>
        
                    <div *ngIf="endorsementService._enCode === policyConstant?.Manufacturingyearonly_Code" class="col-6">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="labelName d-block">Manufacturing Year</label>
                                    <label class="labelValue">{{endorsementDetails?.yearOfManufacture ? endorsementDetails?.yearOfManufacture : '-'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <ng-container *ngIf="isPremiumCalculated">
            <div class="container-fluid" *ngIf="endorsementDetails.discountAmount > 0 && endorsementDetails.discountRate > 0">
                <div class="row newold-endorsement">
                    <!-- Old Details Section -->
                    <div class="col-6"
                        *ngIf="responseData.enCode === policyConstant?.NoclaimBonus_Code || responseData.enCode === policyConstant?.TransferofInsurance_Code">
                        <div class="bg-light">
                            <h6>Old Details</h6>
                            <div class="row mb-2">
                                <div class="col">
                                    <label class="labelName d-block">No Claims Bonus Amount</label>
                                    <label class="labelName d-block">No Claims Bonus %</label>
                                </div>
                                <div class="col" *ngIf="endorsementDetails.olddiscountAmount > 0 && endorsementDetails.olddiscountRate > 0">
                                    <p class="labelValue m-0">{{endorsementDetails.olddiscountAmount ?? '-'}}</p>
                                    <p class="labelValue m-0">{{endorsementDetails.olddiscountRate ?? '-'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- New Details Section -->
                    <div class="col-6"
                        *ngIf="(endorsementDetails.discountAmount > 0 && endorsementDetails.discountRate > 0) && (responseData.enCode === policyConstant?.NoclaimBonus_Code || responseData.enCode === policyConstant?.TransferofInsurance_Code)">
                        <div class="bg-light">
                            <h6>New Details</h6>
                            <div class="row mb-2">
                                <div class="col">
                                    <label class="labelName d-block">No Claims Bonus Amount</label>
                                    <label class="labelName d-block">No Claims Bonus %</label>
                                </div>
                                <div class="col" *ngIf="endorsementDetails.discountAmount > 0 && endorsementDetails.discountRate > 0">
                                    <p class="labelValue m-0">{{endorsementDetails.discountAmount ?? '-'}}</p>
                                    <p class="labelValue m-0">{{endorsementDetails.discountRate ?? '-'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="isPremiumVisibility">
            <div>
                <div class="row">
                    <div class="col-md-6">
                    </div>
                    <div class="col-md-6 text-end">
                        <div class="calculate-Premium pe-3 pb-3">
                            <div class="grid d-flex align-items-center justify-content-between p-2 border-0"
                                *ngIf="responseData.endorsementPremium>0">
                                <div class="label">Endorsement Premium Taxable Value</div>
                                <div class="price">{{ responseData.endorsementPremium | currency: 'INR' }}</div>
                            </div>
                            <div class="grid d-flex align-items-center justify-content-between p-2"
                                *ngIf="responseData.transferFeeAmount>0">
                                <div class="label">Transfer Fee</div>
                                <div class="price">{{ responseData.transferFeeAmount | currency: 'INR' }}</div>
                            </div>
                            <div class="grid d-flex align-items-center justify-content-between p-2"
                                *ngIf="responseData.cgst>0">
                                <div class="label">CGST</div>
                                <div class="price">{{ responseData.cgst | currency: 'INR' }}</div>
                            </div>
                            <div class="grid d-flex align-items-center justify-content-between p-2"
                                *ngIf="responseData.sgst>0">
                                <div class="label">SGST</div>
                                <div class="price">{{ responseData.sgst | currency: 'INR' }}</div>
                            </div>
                            <div class="grid d-flex align-items-center justify-content-between p-2"
                                *ngIf="responseData.igst>0">
                                <div class="label">GST</div>
                                <div class="price">{{ responseData.igst | currency: 'INR' }}</div>
                            </div>
                            <div class="grid d-flex align-items-center justify-content-between p-2 finalPremium">
                                <div class="label">Total Endorsement Premium(Including Tax):</div>
                                <div class="price">{{ responseData.endorsementTotalPremium | currency: 'INR' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container>
            <div class="mainform h-100 overflow-hidden">

                <!-- <h5 class="my-3"> IMD Details </h5>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="labelName d-block">IMD Name</label>
                            <label class="labelValue">{{ responseData?.imdName }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">IMD Code</label>
                            <label class="labelValue">{{ responseData?.imdCode }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">IMD Contact</label>
                            <label class="labelValue">{{ responseData?.imdContact }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">IMD Servicing Branch</label>
                            <label class="labelValue">{{ responseData?.imdBranchName }}</label>
                        </div>
                    </div> -->

                <h5 class="my-3"> Declaration by Insured </h5>
                <div class="row">
                    <div class="col-md-12">
                        <mat-slide-toggle [(ngModel)]="isDeclarationAccepted" aria-checked="true" class="h-auto">
                            <span class="text-wrap">
                                I/We hereby declare that the statements made by me/us in this Proposal Form
                                and
                                annexures if any are true to the best of my/ our knowledge and belief and
                                I/We
                                hereby
                                agree that this declaration shall form the basis of the contract between
                                me/us
                                and
                                the
                                “Liberty General Insurance Limited. If any additions or altercations are
                                carried
                                out
                                in
                                the risk proposed after the submission of this proposal form then the same
                                should be
                                conveyed to the insurers immediately.

                                Prohibition of Rebates(Section 41) of Insurance Act No person shall or offer
                                to
                                allow
                                either directly or indirectly as an inducement to any person to take out or
                                renew of
                                continue an insurance in respect of any kind of risk relating to lives or
                                property
                                in
                                India, any rebate of whole or part of the commission payable or any rebate
                                of
                                the
                                premium shown on the policy, nor shall any person taking out or renewing or
                                continuing a
                                policy accept any rebate except such rebate as maybe allowed in accordance
                                with
                                the
                                published prospectuses or tables of the Insurer.

                                Any person making default in complying with the provisions of this section
                                shall
                                be
                                punishable with Fine, which may extend to Five Hundred Rupees. Insurance is
                                the
                                subject
                                to matter of solicitation.
                            </span>
                            <a href="#" class="tooltipicon" data-bs-toggle="tooltip" data-bs-title="Default tooltip">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15"
                                    fill="none">
                                    <g opacity="0.5">
                                        <path
                                            d="M6.4165 4.58341H7.58317V5.75008H6.4165V4.58341ZM6.99984 10.4167C7.32067 10.4167 7.58317 10.1542 7.58317 9.83341V7.50008C7.58317 7.17925 7.32067 6.91675 6.99984 6.91675C6.679 6.91675 6.4165 7.17925 6.4165 7.50008V9.83341C6.4165 10.1542 6.679 10.4167 6.99984 10.4167ZM6.99984 1.66675C3.77984 1.66675 1.1665 4.28008 1.1665 7.50008C1.1665 10.7201 3.77984 13.3334 6.99984 13.3334C10.2198 13.3334 12.8332 10.7201 12.8332 7.50008C12.8332 4.28008 10.2198 1.66675 6.99984 1.66675ZM6.99984 12.1667C4.42734 12.1667 2.33317 10.0726 2.33317 7.50008C2.33317 4.92758 4.42734 2.83341 6.99984 2.83341C9.57234 2.83341 11.6665 4.92758 11.6665 7.50008C11.6665 10.0726 9.57234 12.1667 6.99984 12.1667Z"
                                            fill="#333740" />
                                    </g>
                                </svg>
                            </a>
                        </mat-slide-toggle>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 my-3">
                        <div *ngIf="!isCustomerProposalMakePaymentSuccess" class="btngroup justify-content-center">
                            <button mat-raised-button color="primary" (click)="makePayment()">Make
                                Payment</button>
                        </div>
                        <div *ngIf="isCustomerProposalMakePaymentSuccess" class="link">
                            <div class="d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19"
                                    fill="none">
                                    <path
                                        d="M9 5.21289C9.31065 5.21289 9.5625 5.46473 9.5625 5.77539V9.66737L10.8523 8.37767C11.0719 8.15799 11.428 8.15799 11.6477 8.37767C11.8674 8.59734 11.8674 8.95344 11.6477 9.17312L9.39772 11.4231C9.29227 11.5286 9.14917 11.5879 9 11.5879C8.85082 11.5879 8.70772 11.5286 8.60227 11.4231L6.35225 9.17312C6.13258 8.95344 6.13258 8.59734 6.35225 8.37767C6.57192 8.15799 6.92808 8.15799 7.14775 8.37767L8.4375 9.66737V5.77539C8.4375 5.46473 8.68935 5.21289 9 5.21289Z"
                                        fill="#1C274C" />
                                    <path
                                        d="M5.4375 13.2754C5.4375 12.9647 5.68934 12.7129 6 12.7129H12C12.3106 12.7129 12.5625 12.9647 12.5625 13.2754C12.5625 13.586 12.3106 13.8379 12 13.8379H6C5.68934 13.8379 5.4375 13.586 5.4375 13.2754Z"
                                        fill="#1C274C" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M8.95695 1.46289C7.22567 1.46288 5.86889 1.46288 4.81028 1.6052C3.72673 1.75088 2.87171 2.05489 2.20061 2.726C1.5295 3.3971 1.22549 4.25212 1.07981 5.33567C0.937485 6.39428 0.937493 7.75106 0.9375 9.48234V9.56844C0.937493 11.2997 0.937485 12.6565 1.07981 13.7151C1.22549 14.7986 1.5295 15.6537 2.20061 16.3248C2.87171 16.9959 3.72673 17.2999 4.81028 17.4456C5.86889 17.5879 7.22567 17.5879 8.95695 17.5879H9.04305C10.7744 17.5879 12.1311 17.5879 13.1897 17.4456C14.2732 17.2999 15.1283 16.9959 15.7994 16.3248C16.4705 15.6537 16.7745 14.7986 16.9202 13.7151C17.0625 12.6565 17.0625 11.2997 17.0625 9.56844V9.48234C17.0625 7.75106 17.0625 6.39428 16.9202 5.33567C16.7745 4.25212 16.4705 3.3971 15.7994 2.726C15.1283 2.05489 14.2732 1.75088 13.1897 1.6052C12.1311 1.46288 10.7744 1.46288 9.04305 1.46289H8.95695ZM2.9961 3.52149C3.42334 3.09425 4.00138 2.84908 4.96019 2.72017C5.93517 2.58908 7.21633 2.58789 9 2.58789C10.7837 2.58789 12.0648 2.58908 13.0398 2.72017C13.9986 2.84908 14.5766 3.09425 15.0039 3.52149C15.4312 3.94873 15.6764 4.52677 15.8052 5.48558C15.9363 6.46056 15.9375 7.74173 15.9375 9.52539C15.9375 11.309 15.9363 12.5902 15.8052 13.5652C15.6764 14.524 15.4312 15.102 15.0039 15.5293C14.5766 15.9566 13.9986 16.2017 13.0398 16.3306C12.0648 16.4617 10.7837 16.4629 9 16.4629C7.21633 16.4629 5.93517 16.4617 4.96019 16.3306C4.00138 16.2017 3.42334 15.9566 2.9961 15.5293C2.56886 15.102 2.32369 14.524 2.19478 13.5652C2.06369 12.5902 2.0625 11.309 2.0625 9.52539C2.0625 7.74173 2.06369 6.46056 2.19478 5.48558C2.32369 4.52677 2.56886 3.94873 2.9961 3.52149Z"
                                        fill="#1C274C" />
                                </svg>
                                <span class="ms-1" (click)="downloadPdf()">Download Policy</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    <!-- </div>
</div> -->